// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","content":"App_content__3La4L","navigation":"App_navigation__3pqZF"};